import Vue from 'vue';
import Message from '../components/Message.vue';

const MessageConstructor = Vue.extend(Message);

let instance;

const message = {
  success(message, duration = 3000) {
    this.open(message, 'success', duration);
  },
  error(message, duration = 3000) {
    this.open(message, 'error', duration);
  },
  warning(message, duration = 3000) {
    this.open(message, 'warning', duration);
  },
  info(message, duration = 3000) {
    this.open(message, 'info', duration);
  },
  open(message, type = 'info', duration = 3000) {
    if (instance) {
      instance.close();
    }

    instance = new MessageConstructor({
      el: document.createElement('div')
    });

    document.body.appendChild(instance.$el);

    instance.open(message, type, duration);
  },
  close() {
    if (instance) {
      instance.close();
    }
  }
};

export default message;